import getFormattedDate from './getFormattedDate'

const generateCheckAvailDates = () => ({
	checkIn: getFormattedDate(1),
	checkOut: getFormattedDate(2),
})

export default generateCheckAvailDates
